<template>
  <div class="portfolio container">
    <section class="container-flex">
      <h1> Portfolio </h1>
      <div class="img-container">
        <a href="http://www.billtrust.com" target="_blank">
          <progressive-img :src="billtrustLogo" title="Billtrust" alt="Billtrust">
          </progressive-img>
        </a>
      </div>
      <div class="billtrust" v-html="billtrust">

      </div>
    </section>

    <section class="container-flex">
      <div class="img-container">
        <a href="http://www.fansere.com" target="_blank">
          <progressive-img :src="fansereLogo" title="Fansere" alt="Fansere">
          </progressive-img>
        </a>
      </div>
      <div class="fansere" v-html="fansere">

      </div>
    </section>

    <section class="container-flex">
      <div class="img-container">
        <a href="https://influx-news.herokuapp.com/" target="_blank">
          <progressive-img :src="influxLogo" style="max-width: 100%" title="Influx" alt="Influx">
          </progressive-img>
        </a>
      </div>
      <div class="influx" v-html="influx">

      </div>
    </section>
    <section class="container-flex">
      <div class="img-container">
        <a href="https://megamountainpixels.surge.sh" target="_blank">
          <progressive-img :src="mmpLogo" title="MMP" alt="MMP">
          </progressive-img>
        </a>
      </div>
      <div class="megamountainpixels" v-html="megamountainpixels">

      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios';
import billtrustLogo from '../assets/billtrust-logo.png';
import fansereLogo from '../assets/fansere-logo.png';
import influxLogo from '../assets/influx-logo.png';
import mmpLogo from '../assets/mmp-logo.png';
import placeholder from '../assets/placeholder.png';

export default {
  data() {
    return {
      billtrustLogo,
      fansereLogo,
      influxLogo,
      mmpLogo,
      placeholder,
      billtrust: JSON.parse(localStorage.getItem('billtrust')),
      fansere: JSON.parse(localStorage.getItem('fansere')),
      influx: JSON.parse(localStorage.getItem('influx')),
      megamountainpixels: JSON.parse(localStorage.getItem('megamountainpixels')),
    };
  },
  mounted() {
    const currentDate = Math.round(new Date().getTime());
    const date = localStorage.getItem('portfolioDate');
    if (!date || date < currentDate) {
      const spreadsheetID = '1ODg-D54e7jCkCcsWF79yu7B0Ajo1ZdTIY1VFzzdzQJM';
      const url = `https://docs.google.com/spreadsheets/d/${spreadsheetID}/gviz/tq?tqx=out:json`;
      axios.get(url).then((response) => {
        const r = response.data.match(/google\.visualization\.Query\.setResponse\(([\s\S\w]+)\)/);
        if (r && r.length == 2) {
          const table = JSON.parse(r[1]).table;
          const rows = table.rows.map(({c}) => c.map(({v}) => v));
          this.billtrust = rows[1][0];
          this.fansere = rows[1][1];
          this.influx = rows[1][2];
          this.megamountainpixels = rows[1][3];
          localStorage.setItem('billtrust', JSON.stringify(this.billtrust));
          localStorage.setItem('fansere', JSON.stringify(this.fansere));
          localStorage.setItem('influx', JSON.stringify(this.influx));
          localStorage.setItem('megamountainpixels', JSON.stringify(this.megamountainpixels));
          localStorage.setItem('portfolioDate', Math.round(new Date().getTime() + (24 * 3600)));
        }
      });
    }
  },
};

</script>

<style lang="scss" scoped>
  h1 {
    width: 100%;
  }
  a {
    display: block;
  }
  .billtrust {
    width: 100%;
    @include respond-to(medium) {
      width: 50%;
    }
  }
  .fansere {
    width: 100%;
    @include respond-to(medium) {
      width: 50%;
    }
  }
  .influx {
    width: 100%;
    @include respond-to(medium) {
      width: 50%;
    }
  }
  .megamountainpixels {
    width: 100%;
    @include respond-to(medium) {
      width: 50%;
    }
  }
  .img-container {
    width: 100%;
    @include respond-to(medium) {
      width: 40%;
      margin: 0 spacing(base) 0 0;
      max-width: 300px;
    }
  }
  .progressive-image {
    display: block;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    width: 100%;
  }
</style>
